import { render, staticRenderFns } from "./PlotItemCard.vue?vue&type=template&id=0c539e6d&scoped=true"
import script from "./PlotItemCard.vue?vue&type=script&lang=ts"
export * from "./PlotItemCard.vue?vue&type=script&lang=ts"
import style0 from "./PlotItemCard.vue?vue&type=style&index=0&id=0c539e6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c539e6d",
  null
  
)

export default component.exports